import { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center text-neutral-600 dark:text-neutral-400">
      <div className="mb-3 text-neutral-500 dark:text-neutral-500">{icon ?? <Inbox className="h-10 w-10" />}</div>
      <h3 className="text-base font-semibold text-slate-950 dark:text-neutral-100">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
